import React, { useState } from "react";
import { ChromePicker } from "react-color";
import { Button, Typography } from "antd";

const ColorPicker = ({ label, ...props }, ref) => {
    const [isPickerOpen, setIsPickerOpen] = useState(false);

    const closePickerHandler = () => {
        setIsPickerOpen(false);
    };

    return (
        <div style={{ position: "relative" }}>
            {label && <Typography.Title level={5}>{label}</Typography.Title>}
            <Button
                style={{
                    padding: "3px",
                    height: "auto",
                    width: "max-content",
                }}
            >
                <div
                    onClick={() => setIsPickerOpen((prevState) => !prevState)}
                    style={{
                        width: "20px",
                        height: "20px",
                        background: props.value.rgb || props.value,
                        cursor: "pointer",
                    }}
                ></div>
            </Button>
            {isPickerOpen && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: "2",
                    }}
                >
                    <div
                        style={{
                            position: "fixed",
                            top: "0px",
                            right: "0px",
                            bottom: "0px",
                            left: "0px",
                        }}
                        onClick={closePickerHandler}
                    />
                    <ChromePicker
                        ref={ref}
                        {...props}
                        name={props.name}
                        color={props.value}
                        onChange={(color) => props.onChange(color.hex)}
                    />
                </div>
            )}
        </div>
    );
};

export default React.forwardRef(ColorPicker);
